import { cx } from "@light-technology/components";
import duracell from "../../assets/manufacturers/duracell.png";
import ecoflow from "../../assets/manufacturers/ecoflow.png";
import emporia from "../../assets/manufacturers/emporia.png";
import enphase from "../../assets/manufacturers/enphase.png";
import epcube from "../../assets/manufacturers/ep-cube.png";
import foxess from "../../assets/manufacturers/fox-ess.png";
import franklin from "../../assets/manufacturers/franklin.png";
import generac from "../../assets/manufacturers/generac.png";
import genesis from "../../assets/manufacturers/genesis.png";
import hyundai from "../../assets/manufacturers/hyundai.png";
import rivian from "../../assets/manufacturers/rivian.png";
import sigenergy from "../../assets/manufacturers/sigenergy.png";
import solaredge from "../../assets/manufacturers/solaredge.png";
import sonnen from "../../assets/manufacturers/sonnen.png";
import tesla from "../../assets/manufacturers/tesla.png";
import volvo from "../../assets/manufacturers/volvo.png";
import {
  BatteryManufacturer,
  EVSEManufacturer,
  VehicleManufacturer,
  type Manufacturer,
} from "../../state/api.types";
import { enumLookup } from "../../utilities/enum";
import { getManufacturerDisplayName } from "./manufacturers";

const logos: Record<Manufacturer, string> = {
  [BatteryManufacturer.Tesla]: tesla,
  [BatteryManufacturer.SolarEdge]: solaredge,
  [BatteryManufacturer.Enphase]: enphase,
  [BatteryManufacturer.Franklin]: franklin,
  [BatteryManufacturer.EcoFlow]: ecoflow,
  [BatteryManufacturer.Sigenergy]: sigenergy,
  [BatteryManufacturer.Duracell]: duracell,
  [BatteryManufacturer.FoxESS]: foxess,
  [BatteryManufacturer.Sonnen]: sonnen,
  [BatteryManufacturer.Generac]: generac,
  [BatteryManufacturer.EPCube]: epcube,
  [EVSEManufacturer.Emporia]: emporia,
  [VehicleManufacturer.Hyundai]: hyundai,
  [VehicleManufacturer.Volvo]: volvo,
  [VehicleManufacturer.Rivian]: rivian,
  [VehicleManufacturer.Genesis]: genesis,
};

export const ManufacturerIcon = ({
  manufacturer,
  className,
}: {
  manufacturer: string;
  className?: string;
}) => {
  const logo = enumLookup(logos, manufacturer);
  const displayName = getManufacturerDisplayName(manufacturer);
  return (
    <div
      className={cx(
        "overflow-hidden rounded-full border border-secondary",
        className,
      )}
    >
      {logo ? (
        <img
          src={logo}
          alt={displayName}
          className="size-8 object-cover object-center"
        />
      ) : (
        <div className="size-8 bg-primary-solid text-center text-xl text-white">
          {displayName[0]}
        </div>
      )}
    </div>
  );
};
